/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import ImgixWithPrioritizedLoading from 'js/components/ImgixWithPrioritizedLoading';

import { usePageInfo } from 'bundles/unified-description-page-common/contexts/PageInfoContext';

import AIEssentialsImage from 'images/unified-description-page/google-ai-essentials.jpg';
import GoogleCybersecurity from 'images/unified-description-page/google-cybersecurity-v2.png';
import GoogleDataAnalytics from 'images/unified-description-page/google-data-analytics-v2.png';
import GoogleDigitalMarketingEcommerce from 'images/unified-description-page/google-digital-marketing-ecommerce-v2.png';
import GoogleItSupport from 'images/unified-description-page/google-it-support-v2.png';
import GoogleProjectManagement from 'images/unified-description-page/google-project-management-v2.png';
import GooglePromptingEssentials from 'images/unified-description-page/google-prompting-essentials.jpg';
import GoogleUXDesign from 'images/unified-description-page/google-ux-design-v2.png';

const styles = {
  container: css`
    width: 100%;
    border-radius: var(--cds-border-radius-100);
    overflow: hidden;
  `,
  image: css`
    width: 100%;
    height: auto;
  `,
};

export const HeroImage = (): React.ReactElement | null => {
  const { productSlug } = usePageInfo();

  let Image;

  switch (productSlug) {
    case 'google-cybersecurity':
    case 'ciberseguridad-de-google':
    case 'cybersecurite-google':
    case 'google-cybersecurity-jp':
      Image = GoogleCybersecurity;
      break;
    case 'google-data-analytics':
    case 'analise-de-dados-do-google':
    case 'analisis-de-datos-de-google':
    case 'analitik-data-google':
    case 'analytique-des-donnees-google':
    case 'data-analytics-japanese':
    case 'google-data-analytics-arabic':
    case 'google-data-analytics-de':
    case 'google-data-analytics-korean':
      Image = GoogleDataAnalytics;
      break;
    case 'google-digital-marketing-ecommerce':
    case 'google-digital-marketing-ecommerce-ua':
    case 'certificado-de-carrera-de-google-marketing-digital-e-e-commerce':
    case 'marketing-digital-e-e-commerce-do-google':
      Image = GoogleDigitalMarketingEcommerce;
      break;
    case 'google-it-support':
    case 'google-it-arabic':
    case 'google-it-de':
    case 'google-it-pt2':
    case 'google-it-ru':
    case 'google-it-support-ua':
    case 'sertifikat-it-support-profesional-google':
    case 'soporte-de-tecnologias-de-informacion-google':
    case 'soutien-des-ti-de-google':
    case 'suporte-em-ti-do-google':
    case 'support-informatique-google':
    case 'google-it-support-korean':
      Image = GoogleItSupport;
      break;
    case 'google-project-management':
    case 'manajemen-proyek-google':
    case 'gestao-de-projetos-do-google':
    case 'gestion-de-projet-de-google':
    case 'gestion-de-projet-google':
    case 'gestion-de-proyectos-de-google':
    case 'google-proje-yonetimi':
    case 'google-project-management-arabic':
    case 'google-project-management-de':
      Image = GoogleProjectManagement;
      break;
    case 'google-ux-design':
    case 'conception-ux-google':
    case 'desain-ux-google':
    case 'diseno-de-experiencia-del-usuario-ux-de-google':
    case 'google-ux-design-arabic':
    case 'google-ux-design-de':
    case 'ux-design-do-google':
      Image = GoogleUXDesign;
      break;
    case 'google-ai-essentials':
      Image = AIEssentialsImage;
      break;
    case 'google-prompting-essentials':
      Image = GooglePromptingEssentials;
      break;
    default:
      // no op
      break;
  }

  if (!Image) {
    return null;
  }

  return (
    <div css={styles.container}>
      <ImgixWithPrioritizedLoading src={Image} alt="" maxWidth={592} css={styles.image} />
    </div>
  );
};

export default HeroImage;
